/** Identité publique PostDev — NAP et profils sociaux réels (footer). */
export const ORG_STREET_ADDRESS = '2 Impasse Duwet'
export const ORG_POSTAL_CODE = '62190'
export const ORG_LOCALITY = 'Lillers'
export const ORG_REGION = 'Hauts-de-France'
export const ORG_COUNTRY = 'FR'
export const ORG_NAP_LINE = `${ORG_STREET_ADDRESS}, ${ORG_POSTAL_CODE} ${ORG_LOCALITY}, France`

export const ORG_SAME_AS = [
  'https://www.linkedin.com/company/postdev',
  'https://www.facebook.com/profile.php?id=61579827748148',
  'https://www.instagram.com/postdev.fr/'
] as const
